import * as React from 'react';
import {
  IApp,
  ITile,
  NotificationsBL,
  Project,
} from 'matrix-requirements-sdk/client';
import { AnalyticsTile, BigNumber, Card, StylesProvider } from '@matrixreq/ui';
import { createRoot, Root } from 'react-dom/client';
import { sdkInstance } from './Instance';
import { ReviewHelper } from './helpers/ReviewHelper';
import { createRef } from 'react';

const ml = sdkInstance.ml;
const app = sdkInstance.app as IApp;
const matrixsdk = sdkInstance.matrixsdk;
const globalMatrix = sdkInstance.globalMatrix;
const matrixSession = sdkInstance.matrixSession;

export class Tile implements ITile {
  private ref: React.RefObject<TileComponent>;
  root: Root = undefined;
  async render(containerElement: HTMLElement) {
    if (this.root !== undefined) {
      this.root.unmount();
    }
    // let's add a root div to the container
    this.root = createRoot(containerElement);
    this.ref = createRef<TileComponent>();
    this.root.render(
      <StylesProvider>
        <TileComponent ref={this.ref}></TileComponent>
      </StylesProvider>,
    );
  }
  getLinks() {
    return [
      {
        title: '',
        pageId: 'REVIEWS',
      },
    ];
  }

  async canBeRenderedAsync(): Promise<boolean> {
    return true;
  }

  getOrder(): number {
    return 900;
  }

  getTitle(): string {
    return 'Report overview';
  }

  async refresh() {
    return this.ref.current.refresh();
  }
}
interface IProps {}

interface IState {
  value?: number;
  isLoading?: boolean;
  loaded?: string;
  label?: string;
}

class TileComponent extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
    // Get the notifications from the cache
    let notificationCache = sdkInstance['NotificationsBL'].NoticationCache;
    if (notificationCache != undefined) {
      //Filter review notification
      let reviewNotifs = notificationCache
        .getNotifications()
        .filter((n) => n.action.todoType === 'needReview');

      this.state = {
        value: reviewNotifs.length,
        label: 'Open reviews for myself',
        isLoading: false,
        loaded: new Date().toISOString(),
      };
    }
  }
  load() {}
  componentDidMount() {}

  componentWillUnmount() {}

  async refresh() {
    let notifs = await sdkInstance['NotificationsBL'].getAllNotifications();
    //Filter review notification
    let reviewNotifs = notifs.todos.filter(
      (n) => n.action.todoType === 'needReview',
    );
    this.setState((state, prop) => ({
      value: reviewNotifs.length,
      label: 'Open reviews for myself',
      isLoading: false,
      loaded: new Date().toISOString(),
    }));
  }
  render() {
    return (
      <AnalyticsTile
        id={'com.matrixreq.core.review-overview'}
        name={'Review overview'}
        lastUpdated={this.state.loaded ?? ' ?'}
        isLoading={this.state.isLoading}
        onRefreshAction={() => {
          this.refresh();
        }}
        onViewAction={() => {
          // eslint-disable-next-line no-restricted-globals
          history.pushState(
            null,
            '',
            globalMatrix.matrixBaseUrl +
              '/' +
              matrixSession.getProject() +
              +'/REVIEWS',
          );
          //Open the notication overview dashboard
          matrixSession.loadProject(
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            null,
            matrixSession.getProject() + '/REVIEWS',
            true,
          );
        }}
      >
        <BigNumber
          data={{ value: this.state.value, label: this.state.label }}
        ></BigNumber>
      </AnalyticsTile>
    );
  }
}
